import React from "react";
import AssignCarrierContent from "./AssignCarrierContent";
import { AssignCarrierProvider } from "./context/AssignCarrierContext";
import { AssignCarrierFormValues } from "./types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  assignCarrier: (formValues: AssignCarrierFormValues) => any;
  defaultValues: AssignCarrierFormValues;
  resetCarrier: () => void;
};

const AssignCarrier: React.FC<Props> = ({
  isOpen,
  onClose,
  assignCarrier,
  defaultValues,
  resetCarrier,
}) => {
  return (
    <AssignCarrierProvider
      isOpen={isOpen}
      defaultValues={defaultValues}
      resetCarrier={resetCarrier}
    >
      <AssignCarrierContent onSubmit={assignCarrier} onClose={onClose} />
    </AssignCarrierProvider>
  );
};

export default AssignCarrier;
